// External libraries
import React, { useEffect } from 'react';
import base64 from 'base64-paypal';
import { useStoreState } from 'easy-peasy';

// Interal modules
import { features } from '@/lib/features';
import { getToken } from '@/lib/globals';
import { getContent } from '@/lib/content';
import {
  logOnClickForcedSignupBNPL,
  logOnClickOptionalGuestBNPL,
  logWhenCheckingBnplEligibility,
  logWhenDisplayForcedSignupBNPL,
  logWhenDisplayOptionalGuestBNPL,
} from './fpti';

const encodeUrlParams = params => {
  return base64.encode(params, base64.CharacterSet.PPBASE64, '');
};

const getLinkContent = () => {
  if (features.isActive('isForcedSignUp')) {
    return getContent('bnpl.textLink.guest');
  }

  return getContent('bnpl.textLink.signup');
};

const clickHandler = () => {
  if (features.isActive('isForcedSignUp')) {
    logOnClickForcedSignupBNPL();
  } else {
    logOnClickOptionalGuestBNPL();
  }
};

export const BuyNowPayLaterLink = () => {
  const { cancelUrl } = useStoreState(state => state.api);

  const isForcedSignUp = features.isActive('isForcedSignUp');
  const shouldShowBNPL = features.isActive('shouldShowBNPL');

  useEffect(() => {
    if (shouldShowBNPL) {
      logWhenCheckingBnplEligibility(true);
      if (isForcedSignUp) {
        logWhenDisplayForcedSignupBNPL();
      } else {
        logWhenDisplayOptionalGuestBNPL();
      }
    } else {
      logWhenCheckingBnplEligibility(false);
    }
  }, []);

  if (!shouldShowBNPL) {
    return null;
  }

  const hasCancelURL = cancelUrl !== '';
  const params = document.location.search;
  const flowObj = {
    cancelUrl: hasCancelURL
      ? `/checkoutweb/cancelToMerchant?token=${getToken()}`
      : '/', // using '/' to indicate no cancel url case
    returnUrl: `/checkoutweb${params}&fundingSource=paylater&fromSignup=true`,
  };

  const url = `/welcome/flow/gpl?flow=${encodeUrlParams(
    JSON.stringify(flowObj),
  )}&product_flow=PAY_LATER&fltk=${getToken()}`;

  return (
    <p>
      <a href={url} onClick={clickHandler}>
        {getLinkContent()}
      </a>
    </p>
  );
};
